import React from 'react'
import RefreshPNG from 'assets/lordicons/Refresh.png'
import RefreshGIF from 'assets/lordicons/RefreshAnimated.gif'
import RefreshDarkPNG from 'assets/lordicons/RefreshDark.png'
import RefreshDarkGIF from 'assets/lordicons/RefreshAnimatedDark.gif'
import { useTheme } from '@mui/material/styles'
import clsx from 'clsx'
import { useIntl } from 'react-intl'
import IconButton, { IconButtonProps } from './Button/IconButton'

export type RefreshButtonProps = Omit<IconButtonProps, 'children'> & {
	loading?: boolean
}

const RefreshButton = (props: RefreshButtonProps) => {
	const themeMUI = useTheme()
	const { formatMessage } = useIntl()

	const staticImage =
		themeMUI.palette.mode === 'light' ? RefreshPNG : RefreshDarkPNG

	const animatedImage =
		themeMUI.palette.mode === 'light' ? RefreshGIF : RefreshDarkGIF

	const { loading } = props

	return (
		<IconButton
			className="group !bg-transparent"
			size="large"
			edge="start"
			color="inherit"
			aria-label={formatMessage({ id: 'global.refresh' })}
			{...props}
		>
			<>
				<img
					className={clsx(
						'w-14 mt-1 group-hover:hidden',
						loading ? 'hidden' : ''
					)}
					src={staticImage}
					alt={formatMessage({ id: 'global.refresh' })}
				/>
				<img
					className={clsx(
						'w-14 mt-1 group-hover:block',
						loading ? '' : 'hidden'
					)}
					src={animatedImage}
					alt={formatMessage({ id: 'global.refreshing' })}
				/>
			</>
		</IconButton>
	)
}

export default RefreshButton
